<template>
  <AdminPanel>
   <p>Broadcast</p>
  </AdminPanel>
</template>


<script>
// @ is an alias to /src
import AdminPanel from '@/components/ui/AdminPanel.vue'

export default {
  
  name: 'BroadcastView',
  components: {
    AdminPanel
  },
}
</script>

<style scoped>

</style>


